import React from 'react';
import { NavLink } from 'react-router-dom';

export const Error403 = ()=>{
    const schoolCode = window.schoolCode;

    return(
        <div className="errorPage container">
            <h1 className="title">페이지 이용권한이 없습니다.</h1>
            <p>
                페이지 이용권한이 없습니다.<br/>
                이용자에게 문의하세요.
            </p>
            <NavLink exact to={`/${schoolCode}/`} className="btn btn-primary">홈</NavLink>
        </div>
    );
}